import * as React from 'react';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';

import {
  UnifiedUpload,
  UnifiedUploadResult,
} from './UnifiedUpload';
import { ResultView } from './ResultView';
import {
  runParse,
  RunParseResult
} from './run_parse';

const steps = ['Upload', 'Result'];

export default function App() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [runParseResult, setRunParseResult] = React.useState<RunParseResult | null>(null);
  const [parseError, setParseError] = React.useState<string | null>(null);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const onUpload = (r: UnifiedUploadResult) => {
    setParseError(null);
    try {
      setRunParseResult(runParse(r));
      handleNext();
    } catch (err: unknown) {
      if (err instanceof Error) {
        setParseError(err.message);
      } else {
        setParseError("an unknown error occurred");
      }
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: {
            optional?: React.ReactNode;
          } = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>

      { parseError != null && <Alert severity="error">{parseError}</Alert> }
      { activeStep === 0 && <UnifiedUpload onUpload={onUpload} /> }
      { activeStep === 1 && runParseResult && <ResultView runParseResult={runParseResult} /> }

      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button
          color="inherit"
          disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 1 }}
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />
      </Box>
    </Box>
  );
}
